import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { AccordionDetails as MuiExpansionPanelDetails } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';

const roundedBG = color => `linear-gradient(90deg, ${color} 0%, ${color} 2%, ${color}00 2%, ${color}00 98%, ${color} 98%, ${color} 100%)`;
/** @component */


export const ExpansionPanelDetails = withStyles(({
  palette,
  props
}) => createStyles({
  root: {
    padding: 0,
    flexDirection: 'column'
  },
  roundedTopContainer: _objectSpread({
    width: '100%',
    height: 5,
    marginBottom: -5,
    overflow: 'hidden',
    background: roundedBG(palette.background.header)
  }, props.printRules.background),
  cutOut: _objectSpread({
    height: 10,
    width: '100%',
    background: roundedBG(palette.background.paper),
    borderRadius: 4
  }, props.printRules.background),
  roundedBottomContainer: _objectSpread({
    position: 'absolute',
    bottom: 0,
    width: '100%',
    height: 5,
    marginTop: -5,
    overflow: 'hidden',
    background: roundedBG(palette.background.header)
  }, props.printRules.background)
}))((_ref) => {
  let {
    classes: {
      roundedTopContainer,
      cutOut,
      roundedBottomContainer
    },
    children,
    top,
    bottom
  } = _ref,
      classes = _objectWithoutProperties(_ref.classes, ["roundedTopContainer", "cutOut", "roundedBottomContainer"]),
      props = _objectWithoutProperties(_ref, ["classes", "children", "top", "bottom"]);

  return /*#__PURE__*/React.createElement(MuiExpansionPanelDetails, _extends({
    classes: classes
  }, props), top ? /*#__PURE__*/React.createElement("div", {
    className: roundedTopContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: cutOut
  })) : null, children, bottom ? /*#__PURE__*/React.createElement("div", {
    className: roundedBottomContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: cutOut,
    style: {
      marginTop: -5
    }
  })) : null);
});
export default ExpansionPanelDetails;